import type { ThemeKeys } from "../../theme/new"
import { Icon, type IconName } from "../Icon"
import { Text } from "../Text"
import styles from "./SelectButton.module.css"

export interface SelectButtonProps {
  textContent: string
  onSelect: () => void
  icon?: IconName
  color?: ThemeKeys<"color">
  disabled?: boolean
}

/**
 * Full-width button to be used in a dropdown-like list of buttons
 *
 * **Use DropdownMenu instead if you need the full feature set**
 */
export function SelectButton(props: SelectButtonProps) {
  const { textContent, onSelect, icon, color = "grey12", disabled } = props

  return (
    <button
      className={styles.footerButton}
      onClick={onSelect}
      disabled={disabled}
    >
      {icon && <Icon name={icon} color="grey11" size="small" />}
      <Text color={color}>{textContent}</Text>
    </button>
  )
}
